import { httpRequest } from './httpClient'

export const listCategories = () =>
  httpRequest('/api/export/categories', { method: 'GET' })

export const analyzeAttributes = (category, images) =>
  httpRequest('/api/export/analyze-attributes', {
    method: 'POST',
    body: { category, images }
  })

export const buildPack = (sku, productJson, images) =>
  httpRequest('/api/export/build-pack', {
    method: 'POST',
    body: { sku, productJson, images },
    responseType: 'blob'
  })
